export default "__VITE_ASSET__Bv66b6vM__";